import React, { useState } from "react";
import { signInWithPopup, GoogleAuthProvider, getAuth, signOut } from "firebase/auth";
import { db, doc, getDoc } from "../firebase";
import { FaGoogle, FaTimes } from "react-icons/fa";
import styles from './CustomLoginDialog.module.css';

const CustomLoginDialog = ({ open, onClose, onLoginSuccess }) => {
  const [error, setError] = useState("");
  const auth = getAuth();
  const provider = new GoogleAuthProvider();

  if (!open) return null;

  const handleLogin = async () => {
    setError("");
    try {
      const result = await signInWithPopup(auth, provider);
      const loggedInUser = result.user;

      // Verifica si el correo está autorizado en Firestore
      const userDoc = doc(db, "users", loggedInUser.email);
      const userSnap = await getDoc(userDoc);

      if (userSnap.exists()) {
        const userData = userSnap.data();
        const fullUser = { ...loggedInUser, role: userData.role };
        onLoginSuccess(fullUser);
      } else {
        setError("Este correo no está autorizado. Por favor, contacta con el administrador.");
        await handleLogout();
      }
    } catch (err) {
      console.error("Error durante el inicio de sesión:", err);
      setError("Hubo un error al iniciar sesión. Por favor, inténtalo de nuevo.");
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error("Error al cerrar sesión:", err);
      setError("Hubo un error al cerrar sesión.");
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.dialogBackdrop} onClick={handleBackdropClick}>
      <div className={styles.dialogContent}>
        <button className={styles.closeButton} onClick={onClose}>
          <FaTimes />
        </button>

        <div className={styles.dialogHeader}>
          <img src="/logotrueba.png" alt="Colegio Trueba" className={styles.logoImage} />
          <h2 className={styles.dialogTitle}>Acceso a Trueba Virtual</h2>
        </div>

        <p className={styles.dialogText}>
          Inicia sesión con tu cuenta institucional para acceder a la plataforma
        </p>
        
        <button 
          className={styles.googleButton} 
          onClick={handleLogin}
        >
          <FaGoogle className={styles.googleIcon} />
          <span>Iniciar sesión con Google</span>
        </button>

        {error && <p className={styles.errorMessage}>{error}</p>}
      </div>
    </div>
  );
};

export default CustomLoginDialog;